module.exports = __webpack_public_path__ + "img/Cutting.16cf819a.png";